<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-24 16:46:24
 * @LastEditTime: 2021-01-20 14:11:34
-->
<template>
  <div id="home">
    <div class="home-wrap">
      <section class="search">
        <div class="title">条件筛选</div>
        <el-form :inline="true" :model="form" class="search-form">
          <el-form-item label="包名">
            <el-select
              v-model="form.pkg"
              multiple
              collapse-tags
              style="width: 350px"
              placeholder="请选择（默认所有）"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期(默认七天)"
              end-placeholder="结束日期(默认七天)"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </section>
      <section class="data-wrap">
        <div class="title">数据总揽</div>
        <ul class="data-box">
          <li>
            <div class="db-top">
              <span>已处理问题</span>
              <strong>{{ allNum }}</strong>
            </div>
            <div class="db-bottom"><span>当前已处理数量</span>{{ allNum }}</div>
          </li>
          <!-- <li>
            <div class="db-top">
              <span>无效会话数量</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>访客总量</span>1</div>
          </li>
          <li>
            <div class="db-top">
              <span>会话中解决数量</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>消息总量</span>1</div>
          </li>
          <li>
            <div class="db-top">
              <span>反馈开发数量</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>留言总量</span>1</div>
          </li> -->
        </ul>
        <!-- <ul class="data-box">
          <li>
            <div class="db-top">
              <span>问题数</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>问题数</span>1</div>
          </li>
          <li>
            <div class="db-top">
              <span>解决问题数</span>
              <strong>12</strong>
            </div>
            <div class="db-bottom"><span>解决问题数</span>1</div>
          </li>
        </ul> -->
      </section>

      <section class="chart-wrap">
        <div class="title">数据图表</div>
        <div v-for="(item, index) in returnChatData" :key="index">
          <line-chart :chartdata="item.data" :options="item.option" />
        </div>
        <!-- <line-chart :chartdata="chartData" :options="chartOptions" /> -->
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getReportList } from "../../api/develop";
import { tagsList } from "../../api/chat";
import lineChart from "./line";
export default {
  name: "Dashboard",
  computed: {
    ...mapGetters(["name"]),
  },
  components: {
    lineChart,
  },
  data() {
    return {
      returnChatData: [],
      chartData: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Chart.js Line Chart",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      form: {
        pkg: [],
        date: "",
      },
      options: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      allNum: 0,
    };
  },

  methods: {
    onSubmit() {
      let st = this.form.date ? this.form.date[0] : "";
      let et = this.form.date ? this.form.date[1] : "";
      let pkg = this.form.pkg ? this.form.pkg.join(",") : "";
      let params = {
        st,
        et,
        pkg,
      };
      getReportList(params).then((res) => {
        let resList = [];
        let aNum = 0;
        for (let key in res) {
          aNum =
            aNum +
            res[key].c.reduce((pre, nex) => {
              return pre + nex;
            });

          resList.push({
            data: {
              type: "line",
              labels: res[key].dt,
              datasets: [
                {
                  label: "解决数量",
                  data: res[key].c,
                  borderColor: "#f87979",
                  borderWidth: 2,
                  fill: false,
                },
              ],
            },
            option: {
              responsive: true,
              maintainAspectRatio: false,
              title: {
                display: true,
                text: key,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },
            },
          });
        }

        this.allNum = aNum;
        this.returnChatData = resList;
      });
    },
  },

  mounted() {
    let _group = JSON.parse(localStorage.getItem("pkg"));
    let resList = [];
    _group.forEach((gVal) => {
      resList.push({
        value: gVal.pkg,
        label:
          gVal.os === 1 ? gVal.group + " - Android" : gVal.group + " - Ios",
      });
    });
    this.options = resList;

    // 初始化图表
    this.onSubmit();

    tagsList().then((res) => {
      localStorage.setItem("issue", JSON.stringify(res.issue))
    });
  },
};
</script>

<style lang="scss" scoped>
#home {
  padding-top: 40px;
}
.home-wrap {
  padding-left: 100px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.data-wrap {
  .data-box {
    display: flex;
    padding-left: 0;
    li {
      width: 200px;
      height: 150px;
      margin-right: 20px;
      border: 1px solid #dddddd;
      list-style: none;
      .db-top {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 90px;
        width: 100%;
        font-size: 12px;
        color: #333333;
        strong {
          margin-top: 10px;
          font-size: 20px;
          color: #409eff;
        }
      }
      .db-bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #dddddd;
        height: 58px;
        width: 100%;
        background: #fafafa;
        font-size: 12px;
        color: #333333;
        span {
          margin-right: 10px;
        }
      }
    }
  }
}
.chart-wrap {
  margin-top: 40px;
  padding-right: 100px;
}
.search {
  margin-bottom: 10px;
}
.search-form {
  margin-top: 16px;
}
</style>
